// extracted by mini-css-extract-plugin
module.exports = {"view-info":"view-info--3kkii","title":"title--1Zp64","description":"description--3PfvE","image":"image--2MMQR"};